/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Billing_Board_Cond_State_PaidInputs */



/**
* | output |
* | --- |
* | "already paid" |
*
* @param {Partner_Billing_Board_Cond_State_PaidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_billing_board_cond_state_paid = /** @type {((inputs?: Partner_Billing_Board_Cond_State_PaidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Billing_Board_Cond_State_PaidInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("bereits bezahlt")
	return /** @type {LocalizedString} */ ("already paid")
});